import React, {Fragment, PropsWithChildren} from "react";

type IProps = PropsWithChildren<{when: unknown}>;

export const Exist: React.FC<IProps> = ({when, children}) => (
	<Fragment>{when ? children : null}</Fragment>
);
